import styled from "@emotion/styled";
import { Col, Row, Table } from "antd";
import { CustomButon } from "./CommonHeader";
import touzi4 from "../../../../images/touzi-4.png";
import jiansheImg from "../../../../images/jianshe-4.png";
import jianshebox from "../../../../images/jianshe-box.png";
import jiansheActive from "../../../../images/jianshe-item.png";
import th from "../../../../images/th1.png";
import tr from "../../../../images/tr.png";
import { ColumnsType } from "antd/es/table/interface";
import YearPicker from "../../../../components/YearPicker";
import xiangmuImg from "../../../../images/xiangmu-6.png";
import { DualAxes } from "@ant-design/plots";
import { useEffect, useRef, useState } from "react";
import request from "../../../../utils/request";
import { useCallback } from "react";
import dayjs from "dayjs";

const Layout = styled.div`
  .flex {
    display: flex;
  }
  .ac {
    align-items: center;
  }
  .column {
    flex-direction: column;
  }
  .box-item {
    background-color: rgba(1, 104, 126, 0.9);
    border: 2px solid #00c9d0;
    box-shadow: 0 0 12px #00383f;
    border-radius: 8px;
    padding: 20px 25px;
    width: 1545px;
    margin-top: 15px;
  }

  .filter {
    padding: 25px 25px;
    align-content: center;
    .type {
      font-size: 22px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #feffff;
    }
  }

  .title {
    font-size: 50px;
    font-family: Source Han Sans CN;
    font-weight: 800;
    color: #feffff;
    span {
      color: #00eafe;
    }
  }
  .table-box {
    .table-title {
      font-size: 20px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #d6fdff;
      margin-bottom: 21px;
    }
  }

  .ant-table {
    background-color: transparent;
    thead {
      background-image: url(${th});
    }
    th {
      background-color: transparent !important;
      color: #fff !important;
      font-size: 14px !important;
      border: none !important;
      height: 40px !important;
      padding: 0 !important;
      &::before {
        display: none !important;
      }
    }
    td {
      color: #1cfbff !important;
      border: none !important;
      background-color: transparent !important;
    }
    tr:hover {
      td {
        background-color: transparent !important;
        border: none !important;
      }
    }
    tbody tr {
      background-image: url(${tr});
      border: none !important;
      &:nth-child(odd) {
        // background-image: url();
      }
    }
  }

  .item {
    border: 1px solid #8cc9d5;
    border-radius: 6px;
    padding: 19px 17px;
    margin-bottom: 20px;
    .card-infos {
      margin-left: 20px;
    }
  }

  .name {
    font-size: 20px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #36c8da;
    text-align: center;
  }
  .value {
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #fffefe;
    text-align: center;
  }

  .chart1-title {
    font-size: 24px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #d6fdff;
    margin-bottom: 44px;
  }
`;

export const Operate: React.FC<{ id?: number }> = ({ id }) => {
  // /screen/Index/getCompanyEconomy?id=212&date=2022-12
  const [details, setDetails] = useState<Record<string, any>>({});
  const currentDate = useRef<any>(null);
  const getData = useCallback(() => {
    if (!id) return;
    request
      .get("/screen/Index/getCompanyEconomy", {
        params: {
          id: id,
          date: currentDate.current
            ? dayjs(currentDate.current).format("YYYY-MM")
            : "2022-12",
        },
      })
      .then((res) => {
        setDetails(res.data?.data || {});
      });
  }, [id]);

  useEffect(() => {
    getData();
  }, [getData]);
  const columns: ColumnsType<any> = [
    {
      title: "序号",
      dataIndex: "",
      align: "center",
      render(value, record, index) {
        return index + 1;
      },
    },
    {
      title: "企业名称",
      align: "center",
      dataIndex: "company",
    },
    {
      title: "预警类型",
      align: "center",
      dataIndex: "cat_title",
    },
    {
      title: "预警内容",
      align: "center",
      dataIndex: "desc",
    },
  ];

  const data = [
    {
      type: "Mon",
      value: 455,
      count: 20,
    },
    {
      type: "Tue",
      value: 766,
      count: 10,
    },
    {
      type: "Wed",
      value: 345,
      count: 50,
    },
    {
      type: "Thu",
      value: 500,
      count: 80,
    },
    {
      type: "Fri",
      value: 200,
      count: 40,
    },
    {
      type: "Sat",
      value: 200,
      count: 20,
    },
    {
      type: "Sun",
      value: 200,
      count: 65,
    },
  ];

  const config: React.ComponentProps<typeof DualAxes> = {
    height: 208,
    data: [data, data],
    xField: "type",
    yField: ["value", "count"],
    legend: {
      itemName: {
        formatter(text) {
          return text === "value" ? "月度" : "累计";
        },
        style: {
          fill: "#fff",
        },
      },
    },
    meta: {
      count: {
        formatter(value) {
          return `${value}亿元`;
        },
      },
    },

    tooltip: {
      formatter(datum) {
        return {
          name: datum.count !== undefined ? "累计" : "月度",
          value: datum.count || datum.value,
        };
      },
    },

    geometryOptions: [
      {
        geometry: "column",
      },
      {
        geometry: "line",
        lineStyle: {
          lineWidth: 2,
        },
      },
    ],
  };

  return (
    <Layout>
      <div className="box-item filter">
        <div className="flex">
          <span className="type">年-月</span>
          <YearPicker
            // format={"YYYY-MM"}
            picker="month"
            style={{
              width: 130,
            }}
            onChange={(e) => {
              currentDate.current = e;
              getData();
            }}
          />
        </div>
      </div>
      <div className="box-item">
        <Row gutter={50}>
          <Col span={6}>
            <div className="item flex">
              <img src={xiangmuImg} width="50" height="50" alt="" />
              <div className="card-infos">
                <div className="name">{details.data_1}</div>
                <div className="value">本月规上工业产值（万元）</div>
              </div>
            </div>
          </Col>
          <Col span={6}>
            <div className="item flex">
              <img src={xiangmuImg} width="50" height="50" alt="" />
              <div className="card-infos">
                <div className="name">{details.data_1_0}</div>
                <div className="value">本月规上工业产值同比</div>
              </div>
            </div>
          </Col>
          <Col span={6}>
            <div className="item flex">
              <img src={xiangmuImg} width="50" height="50" alt="" />
              <div className="card-infos">
                <div className="name">{details.data_2}</div>
                <div className="value">本年累计规上工业产值（万元）</div>
              </div>
            </div>
          </Col>
          <Col span={6}>
            <div className="item flex">
              <img src={xiangmuImg} width="50" height="50" alt="" />
              <div className="card-infos">
                <div className="name">{details.data_2_0}</div>
                <div className="value">本年累计规上工业产值同比</div>
              </div>
            </div>
          </Col>
          <Col span={6}>
            <div className="item flex">
              <img src={xiangmuImg} width="50" height="50" alt="" />
              <div className="card-infos">
                <div className="name">{details.data_9}</div>
                <div className="value">本月入库税收（万元）</div>
              </div>
            </div>
          </Col>
          <Col span={6}>
            <div className="item flex">
              <img src={xiangmuImg} width="50" height="50" alt="" />
              <div className="card-infos">
                <div className="name">{details.data_9_0}</div>
                <div className="value">本月入库税收同比</div>
              </div>
            </div>
          </Col>
          <Col span={6}>
            <div className="item flex">
              <img src={xiangmuImg} width="50" height="50" alt="" />
              <div className="card-infos">
                <div className="name">{details.data_10}</div>
                <div className="value">本年累计入库税收（万元）</div>
              </div>
            </div>
          </Col>
          <Col span={6}>
            <div className="item flex">
              <img src={xiangmuImg} width="50" height="50" alt="" />
              <div className="card-infos">
                <div className="name">{details.data_10_0}</div>
                <div className="value">本年累计入库税收同比</div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
      <div className="box-item">
        <div className="chart1-title">
          {details?.economy?.title || "产值趋势"}
        </div>
        {details.economy && (
          <DualAxes
            {...config}
            data={Array(2).fill(
              details.economy.categories.map(
                (subItem: string, subIndex: number) => ({
                  type: subItem,
                  value: details.economy.column[subIndex],
                  count: details.economy.line[subIndex],
                })
              )
            )}
          />
        )}
      </div>

      <div className="box-item table-box">
        <Table
          columns={columns}
          pagination={false}
          dataSource={details.list_logs || []}
          locale={{
            emptyText: "暂无数据",
          }}
        />
      </div>
    </Layout>
  );
};
